module.exports = __webpack_public_path__ + "static/media/home_thumbnail.7641bdc2.jpg";